import { takeLatest } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { createKiosk, updateKiosk } from '../api';
import { handleFormSubmit } from './helpers/handle-api-form-call';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processSaveKiosk(action: any) {
  const { data, formikActions } = action;
  const { id, serviceProviderId } = data;
  yield handleFormSubmit({
    id,
    formikActions,
    updateFn: async () => updateKiosk(id, { serviceProviderId, ...data }),
    createFn: async () => createKiosk({ serviceProviderId, ...data })
  });
}

export default function* saveKioskSaga() {
  yield takeLatest(AT.SAVE_KIOSK_SAGA, processSaveKiosk);
}
